import CarouselImage1 from 'assets/images/landing/carousel-image-1.jpg';
import CarouselImage2 from 'assets/images/landing/carousel-image-2.jpg';
import CarouselImage3 from 'assets/images/landing/carousel-image-3.jpg';
import CarouselImage4 from 'assets/images/landing/carousel-image-4.jpg';
import CarouselImage5 from 'assets/images/landing/carousel-image-5.png';

export const CAROUSEL_ITEMS = [
  { src: CarouselImage1 },
  { src: CarouselImage2 },
  { src: CarouselImage3 },
  { src: CarouselImage4 },
  { src: CarouselImage5 },
];
